export const AccountStatus = {
  BANNED: 'BANNED',
  ACTIVE: 'ACTIVE'
}



// WEBPACK FOOTER //
// ./src/constants/AccountStatus.js